import queryString from 'query-string'
import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'

function getCustomerDetails(filters) {
  let query = queryString.stringify({
    mobile: filters
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/customer-details?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}

export default {
  getCustomerDetails
}



// WEBPACK FOOTER //
// ./src/services/customer-details-service.js